<import from="../menu-entry/menu-entry"></import>

<div>
  <mdc-top-app-bar style="position: relative; background: transparent; color: #000;  z-index: 2;">
    <mdc-top-app-bar-row>
      <mdc-top-app-bar-section start>
        <mdc-top-app-bar-title>MMAR VizRep Design Client</mdc-top-app-bar-title>
      </mdc-top-app-bar-section>

      <mdc-top-app-bar-section center>
        <!-- <menu-entry menu-entry.bind="fileMenu"></menu-entry>
        <menu-entry menu-entry.bind="viewMenu"></menu-entry>
        <menu-entry menu-entry.bind="editMenu"></menu-entry>
        <menu-entry menu-entry.bind="diagramMenu"></menu-entry>
        <menu-entry menu-entry.bind="settingsMenu"></menu-entry> -->



      </mdc-top-app-bar-section>

      <mdc-top-app-bar-section end>
      </mdc-top-app-bar-section>
    </mdc-top-app-bar-row>
  </mdc-top-app-bar>

</div>